<script setup lang="ts">
const props = defineProps<{
    title: string;
    icon: string;
    navItems?: IPageNavItem[];
    loading?: boolean;
    showStatus?: boolean;
    status?: 0 | 1;
}>()

export interface IPageNavItem {
    name: string;
    title: string;
    params: any;
    icon: string;
    disabled?: boolean;
}

</script>

<template>
    <v-container v-if="!loading">
        <v-toolbar density="compact" :title="title" class="rounded-t" :rounded="!navItems?.length">
            <template #prepend>
                <v-icon class="ml-2" :icon="icon"></v-icon>
            </template>
            <template v-slot:title>
                <div class="d-flex align-center">
                    <span class="text-h6">{{ title }}</span>
                    <v-chip v-if="showStatus" class="ma-2 text-white"
                        :color="status === 1 ? 'green' : 'red'" variant="flat">
                        {{ status === 1 ? 'Active' : 'Inactive' }}
                    </v-chip>
                </div>
            </template>
            <template #append>
                <slot name="tbactions"></slot>
            </template>
        </v-toolbar>
        <v-toolbar v-if="navItems?.length" density="compact" class="rounded-b">
            <v-spacer></v-spacer>
            <v-slide-group show-arrows nav>
                <v-slide-group-item v-for="navItem in navItems">
                    <v-btn :to="{ name: navItem.name, params: navItem.params }"
                        :prepend-icon="navItem.icon ? navItem.icon : ''">
                        {{ navItem.title }}
                    </v-btn>
                </v-slide-group-item>
            </v-slide-group>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-container>
            <slot></slot>
        </v-container>
    </v-container>
    <v-container v-else>
        <v-overlay :model-value="loading" class="align-center justify-center" persistent>
            <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>